import api from '../axios';
/* eslint-disable */
export const apiGetLiveVidoeInfo = params => api.post('/live/getLivePullUrl', params);

export const apiGetLiveViewReport = params => api.post('/live/viewReportH5', params);

// 主播直播配置-是否有购物车
export const apiGetLiveHasCart = params => api.post('/user/live/config/hasCart', params);
// 主播直播配置-购物车商品列表
export const apiGetLiveCartGoodst = params => api.post('/user/live/config/cartGoods', params);
// 商品信息上报
export const apiGoodsReport = params => api.post('/user/live/config/goodsReport', params);
// 点赞
export const apiAddPointup = params => api.post('/live/addPointup', params);
// 直播预告
export const apiAppLiveNotice = params => api.post('/user/live/notice/find', params);
